import React from 'react';

export default function UserProfileIcon({ className = '', title }) {
  return (
 <svg
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M12.8852 10.201C14.3219 9.17434 15.2576 7.51283 15.2576 5.64102C15.2576 2.53056 12.6747 0 9.5 0C6.32526 0 3.74242 2.53056 3.74242 5.64102C3.74242 7.51283 4.67801 9.17434 6.11484 10.201C2.54316 11.5401 0 14.933 0 18.8974C0 20.6082 1.42056 22 3.16667 22H15.8333C17.5794 22 19 20.6082 19 18.8974C19 14.933 16.4568 11.5401 12.8852 10.201ZM5.46971 5.64102C5.46971 3.46371 7.2777 1.69232 9.5 1.69232C11.7223 1.69232 13.5303 3.46371 13.5303 5.64102C13.5303 7.81834 11.7223 9.58977 9.5 9.58977C7.2777 9.58977 5.46971 7.81834 5.46971 5.64102ZM15.8333 20.3077H3.16667C2.37299 20.3077 1.72729 19.675 1.72729 18.8974C1.72729 14.6982 5.21407 11.282 9.50004 11.282C13.786 11.282 17.2728 14.6982 17.2728 18.8974C17.2728 19.675 16.6271 20.3077 15.8333 20.3077Z"
        fill="currentColor"
      />
    </svg>

  );
}

